import { useRuntimeConfig } from '../providers/RuntimeConfigProvider.js';
import { usePeriodicMeValidation } from './usePeriodicMeValidation.js';
import { useProactiveSessionRefresh } from './useProactiveSessionRefresh.js';

/** Mounts proactive refresh + periodic `/me` when a session exists (W1 §4.3–§4.4). */
export function ProactiveSessionRefresh(): null {
  const config = useRuntimeConfig();
  useProactiveSessionRefresh(config.sessionRefreshIntervalMs);
  usePeriodicMeValidation(config.sessionRefreshIntervalMs);
  return null;
}
